import { Box, Stack, Typography } from "@mui/material";
// utils
import { formatNumberKMB } from "../../../utils/helpers";

const Metrics = ({ item }) => {
  const medianViews = item?.overall_median_views || 0;
  const engagementRate = item?.overall_engagement_rate_percentage || 0;
  const conversionRate = item?.overall_conversion_percentage || 0;

  return (
    <Stack direction="row" gap={1} flex={1}>
      <Box sx={{ flex: 1, textAlign: "left" }}>
        <Typography fontSize={12} fontWeight={500} sx={{ lineHeight: "20px" }}>
          {formatNumberKMB(medianViews)}
        </Typography>
        <Typography fontSize={10} fontWeight={400} lineHeight="16px">
          Avg Views
        </Typography>
      </Box>
      <Box sx={{ flex: 1, textAlign: "left" }}>
        <Typography fontSize={12} fontWeight={500} sx={{ lineHeight: "20px" }}>
          {engagementRate.toFixed(1)}%
        </Typography>
        <Typography fontSize={10} fontWeight={400} lineHeight="16px">
          Engagement
        </Typography>
      </Box>
      <Box sx={{ flex: 1, textAlign: "left" }}>
        <Typography fontSize={12} fontWeight={500} sx={{ lineHeight: "20px" }}>
          {conversionRate.toFixed(1)}%
        </Typography>
        <Typography fontSize={10} fontWeight={400} lineHeight="16px">
          Conversion
        </Typography>
      </Box>
    </Stack>
  );
};

export default Metrics;
